import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { NewbuildingBrokerSelfRequestFormBanner } from './NewbuildingBrokerSelfRequestFormBanner';
import { trackBannerClick, trackBannerShow } from './tracking';
import { requestAuthentication } from 'shared/actions/authentication';
import { setNewbuildingBrokerSelfRequestFormWidgetActive } from 'shared/actions/newbuildingBrokerSelfRequestFormWidget';
import { Dispatch } from 'shared/common/state';
import { selectNewbuildingBrokerConsultantBannerButtonText } from 'shared/selectors/newbuildingBrokerConsultantBanner';
import { selectNewbuildingBrokerSelfRequestFormWidgetLoading } from 'shared/selectors/newbuildingBrokerSelfRequestFormWidget';
import { getUser } from 'shared/selectors/user';

export const NewbuildingBrokerSelfRequestFormBannerContainer: React.FC = () => {
  const dispatch: Dispatch = useDispatch();

  const buttonText = useSelector(selectNewbuildingBrokerConsultantBannerButtonText);
  const loading = useSelector(selectNewbuildingBrokerSelfRequestFormWidgetLoading);
  const user = useSelector(getUser);

  const handleButtonClick = React.useCallback(() => {
    trackBannerClick();

    if (!user.isAuthenticated) {
      dispatch(
        requestAuthentication({
          onSuccess: () => () => dispatch(setNewbuildingBrokerSelfRequestFormWidgetActive(true)),
        }),
      );

      return;
    }

    dispatch(setNewbuildingBrokerSelfRequestFormWidgetActive(true));
  }, [dispatch, user]);

  return (
    <ActionAfterViewObserver callback={trackBannerShow}>
      <NewbuildingBrokerSelfRequestFormBanner
        buttonText={buttonText}
        buttonLoading={loading}
        onClick={handleButtonClick}
      />
    </ActionAfterViewObserver>
  );
};
